export default {
	data: {
		selectedImageIndex: undefined
	},
	beforeMount: function () {
		//console.warn("ha", window.location.search);
		var url = new URL(window.location.href);
		var params = {};
		for (let key of url.searchParams.keys()) {
			//console.log("p", key, url.searchParams.get(key));
			params[key] = url.searchParams.get(key);

		}
		this.searchParams = params;
	},
	mounted: function () {
		$('#input_forename').on('change invalid', function () {
			var forename = $(this).get(0);

			forename.setCustomValidity('');

			if (!forename.validity.valid) {
				forename.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#input_surname').on('change invalid', function () {
			var surname = $(this).get(0);

			surname.setCustomValidity('');

			if (!surname.validity.valid) {
				surname.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#input_mobile').on('change invalid', function () {
			var mobile = $(this).get(0);

			mobile.setCustomValidity('');

			if (!mobile.validity.valid) {
				mobile.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});
		$('#input_email').on('change invalid', function () {
			var textfield = $(this).get(0);

			// 'setCustomValidity not only sets the message, but also marks
			// the field as invalid. In order to see whether the field really is
			// invalid, we have to remove the message first
			textfield.setCustomValidity('');

			if (!textfield.validity.valid) {
				textfield.setCustomValidity('Bitte geben Sie eine korrekte E-Mail Adresse ein.');
			}
		});
		$('#ck_privacy').on('change invalid', function () {
			var chekbox = $(this).get(0);

			chekbox.setCustomValidity('');

			if (!chekbox.validity.valid) {
				chekbox.setCustomValidity('Bitte füllen Sie dieses Feld aus.');
			}
		});


	},
	computed: {

		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		},



	},
	methods: {
		allowGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', true);
			location.reload();
		},
		preventGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', false);
			location.reload();
		},
		canShowGoogleMaps: function () {
			var GoogleMaps = localStorage.getItem("allowGoogleMaps");
			if (GoogleMaps === 'true') {
				return true;
			}
			return false;
		},
		isUnitPage: function () {
			//console.log("isUnitPage...");
			if ($('#unitPage').length > 0) {
				//console.log("Yes...");
				return true;
			}
			//console.log("no...");
			return false;
		}
	}

};